import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'

const AddToQuoteButton = ({ handleClick, disabled, deviceType, ...props }) =>
  <Button
    data-at-serp-tire-addtoquote
    data-add-to-quote={ deviceType }
    disabled={ disabled }
    stacked
    narrow
    full
    onClick={ handleClick }>Add to quote
  </Button>

AddToQuoteButton.propTypes = {
  deviceType: PropTypes.string,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func
}

export default AddToQuoteButton
